import { useCallback, useEffect, useState } from 'react'
import ApiServices from '../../services/ApiServices'
import { Strings } from '../../utils/Strings'
import { checkNull } from '../../utils/Helpers'

export function Container() {
  let params = new URL(document.location.toString()).searchParams
  let id = params.get('id')

  const [data, setData] = useState({
    payStatus: false,
    msg: '',
    orderData: {},
    initialLoading: false,
  })

  const loginApi = useCallback(() => {
    ApiServices.login(
      {
        email: process.env.REACT_APP_email,
        password: process.env.REACT_APP_password,
      },
      (res) => {
        if (res.status) {
          orderDetails(res?.data?.auth_token)
        }
      },
      onFail
    )
  }, [])

  useEffect(() => {
    if (!checkNull(id)) {
      setData((prev) => ({ ...prev, initialLoading: true }))
      loginApi()
    } else {
      setData((prev) => ({
        ...prev,
        payStatus: Strings.fail,
        msg: Strings.authFail,
      }))
    }
  }, [id])

  const orderDetails = (token) => {
    const params = {
      id: id,
      token: token,
    }
    ApiServices.getOrderDetails(
      params,
      (res) => {
        if (res?.status) {
          setData((prev) => ({
            ...prev,
            orderData: res?.data,
            initialLoading: false,
            payStatus: res?.data?.status === 'paid' ? Strings.success : false,
            msg: res?.data?.status === 'paid' ? Strings.alreadyPaid : '',
          }))
        }
      },
      (err) => {
        setData((prev) => ({
          ...prev,
          initialLoading: false,
          payStatus: Strings.fail,
          msg: Strings.serverError,
        }))
      }
    )
  }

  const onFail = (err) => {
    setData((prev) => ({ ...prev, initialLoading: false }))
  }

  const func = (key, value) => {
    switch (key) {
      case Strings.success:
        setData((prev) => ({
          ...prev,
          payStatus: Strings.success,
          msg: Strings.paySuccess,
        }))
        break
      case Strings.fail:
        setData((prev) => ({
          ...prev,
          payStatus: Strings.fail,
          msg: checkNull(value) ? Strings.payFail : value,
        }))
        break
      case 'false':
        setData((prev) => ({
          ...prev,
          payStatus: false,
        }))
        break
      case Strings.loading:
        setData((prev) => ({
          ...prev,
          payStatus: Strings.loading,
        }))
        break
      default:
        break
    }
  }

  return { data, func }
}
